<template>
  <div class="bbb-pages">
    <div class="bbb-landing">
      <div class="flex-container">
        <img
          v-if="isVnSource"
          src="/static/img/big-bang-boom/play-text-bbb-vn.png"
          class="play-text"
          width="363"
          height="105"
        />
        <h2 v-if="isVnSource" class="text-greeting" :class="{ vn: isVnSource }">Chào, {{ name }}</h2>
        <h2 v-else class="text-greeting">Hi, {{ name }}!</h2>

        <div class="play-button">
          <router-link :to="url_next" class="play">
            <img
              src="/static/img/cosrx-event/cosrx-event-play-button.png"
              class="play-button"
              width="341"
              height="341"
            />
          </router-link>
        </div>
      </div>
    </div>
    <div class="scan-footers">
      <img src="/static/img/cosrx-event/cosrx-event-footer.png" alt="Soco Vending Machine" />
    </div>
  </div>
</template>

<script>
import VendingMachineTracker from '@/mixins/vending-machine-tracker';
import connectionHelper from '@/mixins/connection-helper.js';

export default {
  name: 'PimplePopLanding',
  mixins: [VendingMachineTracker, connectionHelper],
  data() {
    return {
      idleTimer: null,
      idleTimeout: 30000,
    };
  },
  computed: {
    name() {
      if (this.$SO.size(this.$store.state.auth.userProfile)) {
        const fullName = this.$store.state.auth.userProfile.name;
        return fullName.trim().split(' ')[0] || fullName;
      } else {
        return '';
      }
    },
    isVnSource() {
      return this.$route.query.isvn;
    },
    url_next() {
      return `/cosrx-vending-machine-event/bbb-how-to-play`;
    },
    url_back() {
      return '/cosrx-vending-machine-event';
    },
  },
  mounted() {
    this.startIdleTimer();
    this.addActivityListeners();
  },
  created() {
    this.initOfflineListener({
      pathOffline: 'offline',
      context: this,
    });
  },
  beforeDestroy() {
    this.destroyListener();
    this.clearIdleTimer();
    this.removeActivityListeners();
  },
  methods: {
    startIdleTimer() {
      this.clearIdleTimer();
      this.idleTimer = setTimeout(() => {
        this.handleAutoLogout();
      }, this.idleTimeout);
    },

    clearIdleTimer() {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
        this.idleTimer = null;
      }
    },

    resetIdleTimer() {
      this.startIdleTimer();
    },

    handleAutoLogout() {
      this.$store
        .dispatch('userLogout')
        .then(() => {
          this.$router.push('/cosrx-vending-machine-event/scan-qr');
        })
        .catch(() => {
          this.$router.push('/cosrx-vending-machine-event/scan-qr');
        });
    },

    addActivityListeners() {
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
      events.forEach((event) => {
        document.addEventListener(event, this.handleUserActivity, true);
      });
    },

    removeActivityListeners() {
      const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];
      events.forEach((event) => {
        document.removeEventListener(event, this.handleUserActivity, true);
      });
    },

    handleUserActivity() {
      this.resetIdleTimer();
    },
  },
};
</script>

<style lang="scss" scoped>
.bbb-landing {
  background: #000 url('/static/img/cosrx-event/cosrx-event-bg.png') no-repeat center center;
  background-size: cover;
  min-height: calc(100vh - 161px);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.scan-footers {
  background-color: transparent !important;
  padding: 0 !important;
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
}

.flex-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.play-button {
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.text-greeting {
  font: normal 70px/98px 'Pretendard', sans-serif;
  font-weight: 700;
  margin: 0;
}

.vn {
  font-family: 'Pretendard', sans-serif;
}

.title {
  margin: 0 auto 138px;
  display: block;
}

.play-text {
  margin: 0;
  display: block;
}

@media screen and (max-width: 950px) and (min-width: 900px) {
  .play-button {
    height: 300px;
    width: 300px;
  }

  .text-greeting {
    font: normal 60px/98px 'Pretendard', sans-serif;
  }

  .scan-footers {
    transform: scale(0.86);
    left: -64px;
    bottom: -20px;
  }
}
</style>
